Auth = require 'db/auth'
Controller = require 'controller'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'views/card/card-limits-error'
LabelLimitsErrorView = require 'views/label/label-limits-error-view'
SelectCardPosition = require 'views/card/select-card-position'
Util = require 'lib/util'
View = require 'view'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
track = require 'debug/track'
parseURL = require 'url-parse'
f = require 'effing'
_ = require 'underscore'

module.exports = mixin SelectCardPosition, class CardCopyView extends View
  viewTitleKey: 'copy card'

  initialize: (opts) ->
    @onCopy = opts.onCopy ? (->)

  showCurrentPosition: true

  events:
    'change .js-select-position': 'renderValues'
    'change .js-select-list': 'updatePositionList'
    'change .js-select-board': 'updateBoardData'

    'keydown textarea[name="name"]': 'keydownEvent'
    'click .js-submit': 'submit'
    'submit form': 'submit'

  render: ->
    data = @model.toJSON()
    data.numChecklists = @model.checklistList.length
    data.numMembers = data.idMembers.length
    data.numLabels = data.idLabels?.length ? 0
    data.numAttachments = data.badges.attachments
    data.numComments = data.badges.comments
    data.numStickers = data.stickers.length

    data.hasChecklists = data.numChecklists > 0
    data.hasMembers = data.idMembers.length > 0
    data.hasLabels = data.numLabels > 0
    data.hasAttachments = data.badges.attachments > 0
    data.hasComments = data.badges.comments > 0
    data.hasStickers = data.stickers.length > 0

    data.hasStuff = (data.numChecklists + data.idMembers.length + data.numLabels + data.badges.attachments + data.badges.comments + data.stickers.length) > 0

    data.loading = @loading
    # TODO: TMON-1064 Remove when experiment finishes
    currentBoard = if @model.getBoard().shouldRequestJoinBoard() then @model.getBoard().toJSON() else null
    data.organizations = Auth.me().getOpenBoardsByOrg(true, currentBoard)

    for org in data.organizations
      for board in org.boards
        if board.id == @model.get('idBoard')
          board.selected = true

    partials =
      'move_card_controls': templates.move_card_controls

    @$el.html(
      templates.fill(
        'card_copy',
        data,
        { editable: @model.editable() },
        partials
      )
    )

    @updateBoardData()

    @

  getData: ->
    @loading = true

    ModelLoader.loadCardCopyData @model.get('idBoard'), @model.id
    .finally =>
      @loading = false
      @render()
    .done()

  keydownEvent: (e) ->
    if Keyboard.getKey(e) == Keys.Enter
      Util.stop(e)
      @submit(e)
      return

  submit: (e) ->
    Util.stop(e)

    nameInput = @$('textarea[name="name"]')

    # return if the user hasn't entered a title
    if nameInput.val().trim() == ''
      nameInput.focus().select()
      return

    idListSelected = @$('.js-select-list').find('option:selected').val()
    idBoardSelected = @$('.js-select-board').find('option:selected').val()
    boardSelected = @modelCache.get('Board', idBoardSelected)
    listSelected = boardSelected?.listList.get(idListSelected)
    options = {
      $elem: @$(e.target),
      hasChecklists: @model.checklistList.length > 0,
      hasAttachments: @model.attachmentList.length > 0,
      destinationBoard: boardSelected,
      destinationList: listSelected,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    mandatoryFieldsToKeep = ['due']
    optionalFieldsToKeep = @$('input:checkbox:checked').get().map f.get('name')
    fieldsToKeep = mandatoryFieldsToKeep.concat(optionalFieldsToKeep)

    if idBoardSelected != @model.getBoard().id
      hasLabels = @model.getLabels().length > 0 && _.contains(fieldsToKeep,
        "labels"
      )
      if hasLabels && boardSelected.isOverLimit('labels', 'perBoard')
        PopOver.pushView(new LabelLimitsErrorView())
        return

    @model.copyTo
      name: nameInput.val().trim()
      idList: idListSelected
      pos: @$('.js-select-position').find('option:selected').val()
      keepFromSource: fieldsToKeep
    .then =>
      PopOver.hide()
      @onCopy()
      track("Card", "Copy Card")

    return



// WEBPACK FOOTER //
// ./app/scripts/views/card/card-copy-view.coffee